export default {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    PASSWORD: 'password',
    SELECT: 'select',
    FILE: 'file',
    FOLDER: 'folder',
    URL: 'url',
    YES_NO: 'yes_no',
    CHECKBOX: 'checkbox',
    CHECKLIST: 'checklist',
    SWITCH: 'switch',
    ADDRESS: 'ADDRESS',
    HIDDEN: 'hidden',
    DURATION_PICKER: 'duration_picker',
    PHONE_NUMBER: 'phone_number',
    MULTI_INPUT: 'multi_input',
    SLIDER: 'slider',
};
